import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { IParking } from "../../entity/parking";
import { IParkingPoint } from "../../entity/parking-point";
import { IParkingLotGroup, IParkingLot } from "../../entity/parking-lot";
import Enums from "../../utils/enums";

@Component({
	selector: 'app-dashboard-map',
	templateUrl: './dashboard-map.component.html',
})
export class DashboardMapComponent implements OnChanges {

	@Input() parkings: IParking[];
	@Input() parkingLots: IParkingLotGroup[];

	localGroups: IParkingLotGroup[];
	selectedGroup: IParkingLotGroup;
	paths: IPath[];

	lat: number = 0;
	lng: number = 0;
	zoom: number = 15;

	mapStyles = [
		{
			"featureType": "poi",
			"elementType": "labels.text",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "poi.business",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		}
	];

	public ngOnChanges(): void {
		this.setZoomFromPoints();
		this.setPathsFromParkings();

		if (this.parkingLots != null)
			this.localGroups = [...this.parkingLots];
	}

	public getLotIcon(parkingLot: IParkingLot): string {
		switch (parkingLot.parkingLotStatID) {
			case Enums.eParkingLotStat.Free:
				return '../../../assets/lots/free.png';
			case Enums.eParkingLotStat.Occupied:
				return '../../../assets/lots/occupied.png';
			case Enums.eParkingLotStat.Booked:
				return '../../../assets/lots/booked.png';
			default:
				return '../../../assets/lots/free.png';
		}
	}

	public getClusterIcon(group: IParkingLotGroup) {
		const ocupationRate = (group.occupied * 100) / group.total;

		if (ocupationRate >= 70)
			return '../../../assets/lots/cluster_red.png';

		return '../../../assets/lots/cluster_green.png';
	}

	public selectGroup(group: IParkingLotGroup): void {
		this.selectedGroup = group;
		this.setZoomFromGivenPoints(group.parkingLots);
	}

    public closeGroup(): void {
        this.selectedGroup = null;
        this.setZoomFromPoints();
    }

	private setPathsFromParkings(): void {
		if (this.parkings != null) {
			const paths: IPath[] = [];

			for (const parking of this.parkings) {
				for (const group of parking.groupedParkingPoints) {
					const coordinates: ICoordinates[] = [];
					for (const point of group) {
						coordinates.push({ lat: point.latitude, lng: point.longitude });
					}
					paths.push({ color: parking.color, coordinates });
				}
			}
			this.paths = paths;
		}
	}

	private setZoomFromGivenPoints(points: IParkingLot[]): void {
		if (points != null && points.length > 0) {
			let minX, maxX, minY, maxY;
			// init first point
			((point) => {
				minX = point.latitude;
				maxX = point.latitude;
				minY = point.longitude;
				maxY = point.longitude;
			})(points[0]);
			// calculate rect
			points.map((point) => {
				minX = Math.min(minX, point.latitude);
				maxX = Math.max(maxX, point.latitude);
				minY = Math.min(minY, point.longitude);
				maxY = Math.max(maxY, point.longitude);
			});
			const midX = (minX + maxX) / 2;
			const midY = (minY + maxY) / 2;
			const deltaX = (maxX - minX);
			const deltaY = (maxY - minY);
			const region = {
				latitude: midX,
				longitude: midY,
				latitudeDelta: deltaX,
				longitudeDelta: deltaY,
			};
			const zoom = Math.round(Math.log(360 / region.longitudeDelta) / Math.LN2);
			this.lat = region.latitude;
			this.lng = region.longitude;
			this.zoom = zoom + 1;
		}
	}

	public setZoomFromPoints(): void {
		const points: IParkingPoint[] = [];
		if (this.parkings != null)
			for (const parking of this.parkings)
				for (const pp of parking.parkingPoints)
					points.push(pp)
		if (points != null && points.length > 0) {
			let minX, maxX, minY, maxY;
			// init first point
			((point) => {
				minX = point.latitude;
				maxX = point.latitude;
				minY = point.longitude;
				maxY = point.longitude;
			})(points[0]);
			// calculate rect
			points.map((point) => {
				minX = Math.min(minX, point.latitude);
				maxX = Math.max(maxX, point.latitude);
				minY = Math.min(minY, point.longitude);
				maxY = Math.max(maxY, point.longitude);
			});
			const midX = (minX + maxX) / 2;
			const midY = (minY + maxY) / 2;
			const deltaX = (maxX - minX);
			const deltaY = (maxY - minY);
			const region = {
				latitude: midX,
				longitude: midY,
				latitudeDelta: deltaX,
				longitudeDelta: deltaY,
			};
			const zoom = Math.round(Math.log(360 / region.longitudeDelta) / Math.LN2);
			this.lat = region.latitude;
			this.lng = region.longitude;
			this.zoom = zoom + 1;
		}
	}
}

export interface IPath {
	color: string;
	coordinates: ICoordinates[];
}

export interface ICoordinates {
	lat: number;
	lng: number;
}
